import { render, staticRenderFns } from "./SalesInvoice.vue?vue&type=template&id=c07fa0e0"
import script from "./SalesInvoice.vue?vue&type=script&lang=js"
export * from "./SalesInvoice.vue?vue&type=script&lang=js"
import style0 from "./SalesInvoice.vue?vue&type=style&index=0&id=c07fa0e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports